import { Schema } from "ajv"

export const SigninSchema: Schema = {
  type: "object",
  properties: {
    username: {
      description: "Your email address",
      type: "string",
      format: "email",
      errorMessage: "Please enter a valid email address"
    },
    password: {
      type: "string",
      description: "Your password",
      minLength: 1,
      errorMessage: {
        minLength: "Please enter your password"
      }
    }
  },
  errorMessage: {
    required: {
      email: "Please enter your email address",
      password: "Please enter your password"
    }
  },
  required: ["username", "password"]
}
